import * as React from 'react';
import { useState } from 'react';

import redirect from 'js/lib/coursera.redirect';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import EnrollmentChoiceTypes from 'bundles/enroll-common/common/EnrollmentChoiceTypes';
import {
  choiceTypeToHandleSubmitPromise,
  submitEnrollmentPromise,
} from 'bundles/enroll-common/lib/enrollmentChoiceUtils';
import { getCourseHomeLinkBySlug } from 'bundles/enterprise-legacy-learner-home/utils/courseAndS12nUtils';

import _t from 'i18n!nls/enroll';

type Props = {
  courseId: string;
  courseSlug?: string;
  hasFreeEnrollOption?: boolean;
  onClose: () => void;
};

const PartnerSupportedAccessModal = ({ courseId, courseSlug, hasFreeEnrollOption, onClose }: Props) => {
  const [ctaLoading, setCtaLoading] = useState(false);
  const track = useTracker();

  const handleClick = () => {
    setCtaLoading(true);

    if (ctaLoading) {
      return;
    }

    track('click_button', {
      button: {
        name: 'continue_process',
      },
      modal: {
        name: 'partner_supported_access',
      },
      product: {
        id: courseId,
        type: 'course',
      },
      enrollmentOptions: {
        enrollmentOptionsType: hasFreeEnrollOption ? 'enroll_free_course' : 'audit_course',
      },
    });

    const options = { courseId };
    const enrollmentChoiceType = hasFreeEnrollOption
      ? EnrollmentChoiceTypes.ENROLL_COURSE
      : EnrollmentChoiceTypes.AUDIT_COURSE;
    const handleSubmitPromise = choiceTypeToHandleSubmitPromise[enrollmentChoiceType];
    submitEnrollmentPromise({ handleSubmitPromise, options }).then(
      (data: $TSFixMe /* TODO: type submitEnrollmentPromise */) => {
        if (data.didEnroll) {
          const redirectUrl = courseSlug ? getCourseHomeLinkBySlug(courseSlug) : '/';
          redirect.setLocation(redirectUrl);
        }
      }
    );
  };

  return (
    <Dialog aria-describedby="partner-supported-access-modal-content" onClose={onClose} open>
      <Dialog.HeadingGroup>{_t('Access information')}</Dialog.HeadingGroup>
      <Dialog.Content id="partner-supported-access-modal-content">
        <Typography2 component="p">
          {hasFreeEnrollOption
            ? _t(
                'This course has been made available free of charge through a partner-supported program. You will be able to access all of the course content except for a completion certificate. This is available by upgrading to a paid plan.'
              )
            : _t(
                'This course has been made available free of charge through a partner-supported program. You will be able to access all of the course content except for graded assignments and a completion certificate. These are available by upgrading to a paid plan.'
              )}
        </Typography2>
      </Dialog.Content>
      <Dialog.Actions>
        <Button loading={ctaLoading} disabled={ctaLoading} onClick={handleClick}>
          {_t('Continue')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default PartnerSupportedAccessModal;
